"use client";

import { c as _c } from "react/compiler-runtime";
import ErrorComponent from "@/components/error/Error";
import styles from "@/styles/Home.module.scss";
import { extractErrorDetails } from "@/utils/error-extractor";
import { type FallbackProps } from "react-error-boundary";
function getErrorDigest(error: unknown): string | undefined {
  if (typeof error !== "object" || error === null) {
    return undefined;
  }
  const digest = (error as Record<string, unknown>)["digest"];
  return typeof digest === "string" ? digest : undefined;
}
export default function LayoutErrorFallback(t0) {
  const $ = _c(8);
  const {
    error,
    resetErrorBoundary
  } = t0;
  let t1;
  if ($[0] !== error) {
    t1 = extractErrorDetails(error);
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const errorDetails = t1;
  let t2;
  if ($[2] !== error) {
    t2 = getErrorDigest(error);
    $[2] = error;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const digest = t2;
  let t3;
  if ($[4] !== digest || $[5] !== errorDetails || $[6] !== resetErrorBoundary) {
    t3 = <main className={styles.main}><ErrorComponent stackTrace={errorDetails} digest={digest} onReset={resetErrorBoundary} /></main>;
    $[4] = digest;
    $[5] = errorDetails;
    $[6] = resetErrorBoundary;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}